import React, { useState, useEffect } from 'react';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';
import { getRequest, patchRequest } from 'apis/ApiInstence';

const statusBadgeClass = (status) => {
  if (status === 'approved') return 'badge badge-success';
  if (status === 'rejected') return 'badge badge-danger';
  return 'badge badge-warning';
};

const LeavesList = () => {
  const [leaves, setLeaves] = useState([]);

  const loadInitialData = async () => {
    const res = await getRequest(`leave`, true);
    if (res?.status) {
      setLeaves(res?.data || []);
    } else {
      toast.error('Failed to load leave requests!');
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const handleStatusChange = async (batchId, status) => {
    const res = await patchRequest(`leave/${batchId}`, { status });
    if (res?.status) {
      toast.success(`Leave request ${status}.`);
      loadInitialData();
    } else {
      toast.error('Failed to update leave status!');
    }
  };

  const tableHeaders = [
    { Header: 'Serviceman', id: 'servicemanName', accessor: (row) => row.serviceman?.name || '-' },
    { Header: 'Mobile', id: 'servicemanMobile', accessor: (row) => row.serviceman?.mobile || '-' },
    {
      Header: 'Dates',
      accessor: 'dates',
      Cell: ({ row }) => (row.original.dates || []).join(', '),
    },
    {
      Header: 'Type',
      accessor: 'leave_type',
      Cell: ({ row }) => (row.original.leave_type === 'half' ? 'Half Day' : 'Full Day'),
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => (
        <span className={statusBadgeClass(row.original.status)}>
          {row.original.status}
        </span>
      ),
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) =>
        row.original.status === 'pending' ? (
          <>
            <button
              className="btn editbtn mx-1 my-1"
              onClick={() => handleStatusChange(row.original.id, 'approved')}
            >
              Approve
            </button>
            <button
              className="btn removebtn mx-1 my-1"
              onClick={() => handleStatusChange(row.original.id, 'rejected')}
            >
              Reject
            </button>
          </>
        ) : (
          '-'
        ),
    },
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Leave Requests</h4>
      </div>
      {leaves.length > 0 && (
        <AdminTable tableHeaders={tableHeaders} tableData={leaves} />
      )}
    </div>
  );
};

export default LeavesList;
